'use client';

import { usePathname } from "next/navigation";
import Footer from "./footer";
import FloatingWidget from "./FloatingWidget/FloatingButton";
import ParentStoryBubble from "./ParentStoryBubble/ParentStoryBubble";

export default function GlobalComponents() {
  const pathname = usePathname();
  
  // Don't render FloatingWidget and Footer on booking report, payment, and invoice pages
  const isBookingReportPage = pathname?.startsWith('/booking-report');
  const isPaymentPage = pathname?.startsWith('/payments');
  const isInvoicePage = pathname?.startsWith('/invoices');
  const isIgrowRegistrationPage = pathname === '/registrations/igrow-programme';
  
  if (isBookingReportPage || isPaymentPage || isInvoicePage || isIgrowRegistrationPage) {
    return null;
  }
  
  return (
    <>
      <FloatingWidget />
      <ParentStoryBubble />
      <Footer />
    </>
  );
} 